import { IResponse } from "models";

export enum ActionType {
  VACCINE_CREATE_VENUES = "action/VACCINE_CREATE_VENUES",
  VACCINE_CREATE_VENUES_SUCCESS = "action/VACCINE_CREATE_VENUES_SUCCESS",
  VACCINE_CREATE_VENUES_ERROR = "action/VACCINE_CREATE_VENUES_ERROR",
  VACCINE_CREATE_VENUES_RESET = "action/VACCINE_CREATE_VENUES_RESET",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface ICreateVenuesResponse extends IResponse {
  result: any;
}
